<template>
  <div
    class="presenzaResp-mobile mobile_customize col-xs-24"
    v-loading="loading"
  >

    <div class="elemento row row-custom">  
      <div class="col-2 no-padding"></div>
      <div class="mobile-title col-20 no-padding">{{ $t('presenze.title') }}</div>
      <div class="col-2 no-padding"></div>
    </div>
    <div class="elemento row row-custom">  
      <div class="col-24 no-padding select-wrapper">
        <select v-model="searchFilter.employee"  @change="changeUser()">
          <option
            v-for="(delega) in deleghe"
            :value="delega.valore"
            :key="delega.descrizione"
          >{{ delega.descrizione }}</option>
        </select>
      </div>
    </div>

    <div class="elemento row row-custom">

      <el-table :data="presenze" row-class-name="single riga-hover double" row-key="presenze"
              :empty-text="$t('msg.noDocFound')" v-loading="loadingTable"
              class="el-table_mobile" :cell-class-name=getStato>

        <el-table-column width="10"></el-table-column>
          
        <el-table-column
          :label="$t('presenze.employee')"
          min-width="150">

          <template slot-scope="scope">
            <div class="data-wrapper">
              {{ scope.row.nomex }} {{ scope.row.cognx }}
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center"
                       :label="$t('presenze.date')"
                       width="100">

          <template slot-scope="scope">
            <div class="data-wrapper">
              {{ scope.row.mese}}/{{ scope.row.anno}}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="30">

          <template slot-scope="scope" >
            <div class="name-wrapper" :key="scope.length" @click.stop.prevent>
              <el-tooltip
                placement="left"
                popper-class="popover-mobile"
                effect="light">
                 <template slot="content">
                  <div @click="opRapPresenze(scope.row,'C')" v-if="scope.row.stato === 'A'">
                    <span>{{ $t('btn.convalida') }}</span>
                  </div>
                  <div @click="opRapPresenze(scope.row,'A')" v-if="scope.row.stato === 'A' || scope.row.stato === 'C'">
                    <span>{{ $t('btn.riapri') }}</span>
                  </div>
                  <div @click="stampaConv(scope.row)">
                    <span>{{ $t('btn.print') }}</span>
                  </div>
                </template>
                  
                  <icon class="pointer action" name="riv-more" scale="1.5" ></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

      </el-table>

    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    components: {},
    watch: {
      '$mq.resize': 'resize'
    },
    name: 'Responsabile',
    data () {
      return {
        loading: false,
        loadingTable: false,
        loadingSave: false,
        deleghe: [],
        searchFilter: {
          'employee': '',
          'data': '',
          'anno': '',
          'mese': '',
          'periodo': ''
        },
        presenze: []
      }
    },
    activated: function() {
      this.loading = true
      this.getDeleghe()
      this.loading = false
    },
    deactivated: function(){
      this.loading = false
      this.$set(this, 'deleghe', [])
      let obj = {
        'employee': '',
        'data': '',
        'anno': '',
        'mese': '',
        'periodo': ''
      }
      this.$set(this, 'searchFilter', obj)
      this.$set(this, 'presenze', [])
    },
    methods: {
      getDeleghe: function () {
        this.$http.get('presenze/' + this.$store.state.country + '/deleghe').then(response => {
          if (response.body.rc === 0) {
            let del = []
            for (var i = 0; i < response.body.data.length; i++) {
              let obj = {}
              obj.valore = response.body.data[i].codFisc
              obj.descrizione = response.body.data[i].cognx + ' ' + response.body.data[i].nomex
              del.push(obj)
            }
            this.deleghe = del
          }
          let findUser = false
          if (this.deleghe.find(o => o.valore === response.body.attrib.codFisc) !== undefined) {
            /*this.searchFilter.employee = {
              'valore': response.body.attrib.codFisc,
              'descrizione': response.body.attrib.cognx + ' ' + response.body.attrib.nomex
            }*/
            this.searchFilter.employee = response.body.attrib.codFisc
            findUser = true
          } else if (this.deleghe.length === 1){
            /*this.searchFilter.employee = {
              'valore': this.deleghe[0].valore,
              'descrizione': this.deleghe[0].descrizione
            }*/
            this.searchFilter.employee = response.body.data[0].codFisc
            this.changeUser()
          } else if (this.deleghe.length >= 1 && !findUser){
            this.searchFilter.employee = response.body.data[0].codFisc
            this.changeUser()
          }
          if (findUser) {
            this.changeUser()
          }
        })
      },
      changeUser: function () {
        this.rapPresenze()
      },
      rapPresenze: function () {
        this.loadingTable = true
        this.$set(this, 'presenze', [])
        var obj = {
          params: {
            codFisc: this.searchFilter.employee
          }
        }
        this.$http.get('presenze/' + this.$store.state.country + '/rapportini', obj).then(response => {
          if (response.body.rc === 0) {
            this.presenze = response.body.data.map(function (obj) {
              obj.checkConvalida = false
              obj.checkRiapertura = false
              obj.checkStampa = false
              return obj
            })
            this.checkMail = response.body.attrib.avvisoMail === 'NO' ? false : true
            this.presenze = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loadingTable = false
        })
      },
      mailConv:function (event) {
        //this.loading = true
        let obj = {
          codFisc: this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
          avvisoMail: event ? "SI":"NO"
        }
        this.$http.post('presenze/' + this.$store.state.country + '/mailConv', obj).then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'warning',
              duration: process.env.duration
            })
            this.checkMail = !event;
          }
          this.loading = false
        })
      },
      opRapPresenze:function (row, op) {
        let _this = this;

        let message = "";
        let btnOK = "";
        if (op === 'A') {
          message = this.$i18n.t('presenze.confReopening');
          btnOK = this.$i18n.t('btn.riapri');
        } else {
          message = this.$i18n.t('presenze.confValidation');
          btnOK = this.$i18n.t('btn.convalida');
        }
        this.$confirm(message, 'Info', {
          confirmButtonText: btnOK,
          cancelButtonText: this.$i18n.t('btn.annulla'),
          type: 'info',
          customClass: 'el-message-box-mobile',
          callback: function(action) {
            if (action === 'confirm') {

              // RIAPERTURA   op = 'A'
              // CONVALIDA    op = 'C'

            let codFisc = _this.searchFilter.employee
            let righe = []
            let riga = {
              codFiscDip: row.codFisc,
              anno: row.anno,
              mese: row.mese,
              azione: op
            }
            righe.push(riga)
            _this.loadingSave = true
            let obj = {
              codFisc: codFisc,
              mesi: JSON.stringify(righe)
            }
            _this.$http.post('presenze/' + _this.$store.state.country + '/rapportini', obj).then(response => {
              if (response.body.rc === 0) {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                _this.presenze = [];
                _this.rapPresenze();
              } else {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'warning',
                  duration: process.env.duration
                })
              }
              _this.loadingSave = false
            })
            } else {
              _this.$message({
                showClose: true,
                message: _this.$i18n.t('msg.abort'),
                type: 'info',
                duration: process.env.duration
              })
            }
          }
        });
      },
      stampaConv: function (riga) {
        let righe = [{
          codFiscDip: riga.codFisc,
          anno: riga.anno,
          mese: riga.mese,
        }]
        var obj = {
          params: {
            righe: righe
          }
        }
        this.$http.get('presenze/' + this.$store.state.country + '/print', obj).then(response => {
          if (response.body.rc === 0) {
            let url = ('download/convalide?fileName=' + response.body.data.file + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
            let win = window.open(process.env.baseUrlSpring + url, '_blank')
            win.focus()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'warning',
              duration: process.env.duration
            })
          }
        })
      },
      checkConvalida: function (event) {
        for (var i = 0; i < this.presenze.length; i++) {
          if (this.presenze[i].stato === 'A') this.presenze[i].checkConvalida = event
        }
      },
      checkRiapertura: function (event) {
        for (var i = 0; i < this.presenze.length; i++) {
          if (this.presenze[i].stato === 'A' || this.presenze[i].stato === 'C') this.presenze[i].checkRiapertura = event
        }
      },
      checkStampa: function (event) {
        for (var i = 0; i < this.presenze.length; i++) {
          this.presenze[i].checkStampa = event
        }
      },
      resize: function () {
        let contenitoreHeight = window.innerHeight - 140
        this.tableHeight = contenitoreHeight - 115
      },
      getStato({row, column, rowIndex, columnIndex}) {
        if (columnIndex === 0) {
          //if (row.stato === 'N') return 'stato_0'
          if (row.stato === 'A') return 'stato_1'
          if (row.stato === 'C') return 'stato_2'
        }
        return ''
      }
    },
    beforeMount: function () {
      //this.loading = true
      //this.rapPresenze()
    }
  }
</script>


<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-dialog_mobile";
@import "../../assets/less/el-form_mobile";
@import "../../assets/less/el-table_mobile.less";

.presenzaResp-mobile {
  padding: 0;

  .action {
    height: 20px;
    line-height: 20px;
    span {
      float: right;
      .set-font(@size: 14px, @color: @grayDark, @weight: bold, @family:'os-regular');
      text-transform: capitalize;
      padding-right: 15px;
    }
  }
  .select-wrapper {
    position: relative;
    display: inline-block;
    &:after {
      content: '\0025BC';
      // font: normal normal normal 12px/1 FontAwesome;
      color: #cbb385;
      right: 4%;
      top: -7px;
      height: 26px;
      padding: 15px 0px 0px 8px;
      position: absolute;
      pointer-events: none;
    }
    select {
      .set-font(@size: 18px, @weight: bold, @color: @textTable, @family: 'os-bold');
      width: 100%;
      padding-right: 24px;
      background-color: #fff;
      border-radius: 5px;
      border-color: #cbb385;
      //font-family: Arial, ArialHebrew, sans-serif;
      //font-size: 18px;
      text-align: -moz-center;
      text-align: -webkit-center;
      text-align: center !important;
      //color: #cbb385;
      //margin: 3px;
      padding: 3px;
      -webkit-appearance: none;
      &:focus {
        outline: none;
      }
    }
  }

  .el-tbale {

  }
}
.popover-mobile {
  line-height: 50px;
  .set-font(@size: 18px,@color: @grayTesto, @family: "os-semibold");
  min-width: 250px;
}

</style>


// WEBPACK FOOTER //
// src/components/PresenzeWebMobile/ResponsabileMobile.vue